import React from 'react';
import { ILabelRow } from './types';
import { getFormattedText } from '../utils/getFormattedText';
import { Label } from 'src/components/Tags';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    root: {
        textTransform: 'capitalize',
    },
}));

export const LabelRow = ({ column, item, color, ...props }: ILabelRow) => {
    const classes = useStyles();

    const { field, type } = column;

    const text = getFormattedText({ type, field, item, column });

    return (
        <Label color={color} className={classes.root} {...props}>
            <p>{text}</p>
        </Label>
    );
};
